import { Dialog, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import Button from "components/Forms/CustomButtons/ButtonTS";
import React, { Dispatch, ElementType, SetStateAction } from "react";
import { ActivityItemWorker } from "services/input-core/work-items/@types";
import UploadModalContent from "./UploadModalContent";
import UploadModalContentKuo from "./UploadModalContentKuo";
import { useTranslation } from "react-i18next";
import { TagHeaderModal } from "components/TagHeaderModal";
import { useActivityItemContext } from "store/activityItem";

export enum UploadModalType {
  DEFAULT = "DEFAULT",
  KUO = "KUO",
}

interface UploadModalProps {
  profile: "WORKER" | "SOW";
  type?: UploadModalType;
  modalOpen: boolean;
  fieldglassId?: string;
  uploadType?: boolean;
  setUploadType?: Dispatch<SetStateAction<boolean>>;
  onClose: () => void;
  entityDate?: {
    start: string;
    end: string;
  };
}

const UploadContentMapper: Record<UploadModalType, ElementType> = {
  [UploadModalType.DEFAULT]: UploadModalContent,
  [UploadModalType.KUO]: UploadModalContentKuo,
};

const UploadModal: React.FC<UploadModalProps> = ({
  modalOpen,
  onClose,
  profile,
  uploadType,
  setUploadType,
  fieldglassId,
  type = UploadModalType.DEFAULT,
  entityDate,
}) => {
  const { currentActivityItem } = useActivityItemContext(state => ({
    currentActivityItem: state.currentActivity,
  }));

  const refId = fieldglassId ?? currentActivityItem.fieldglassId;

  const { t } = useTranslation(["modals", "activity-item-table"]);
  

  return (
    <>
      <Dialog
        open={modalOpen}
        fullWidth
        maxWidth="lg"
        scroll="paper"
        onClose={() => {
          onClose();
        }}
        disableBackdropClick
      >
        <DialogTitle>
          <div>{t("documents")}</div>
          <Button
            justIcon
            simple
            color="tumblr"
            round
            size="sm"
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            onClick={onClose}
          >
            <Close />
          </Button>
        </DialogTitle>

        <Divider style={{ backgroundColor: "#808080" }} />

        <TagHeaderModal
          tagsHeader={[
            {
              label: t("activity-code", { ns: "activity-item-table" }),
              content: currentActivityItem.activityItemCode,
            },
            {
              label: t("date", { ns: "activity-item-table" }),
              content: currentActivityItem.activityItemDueDate,
            },
            {
              label: t("action", { ns: "activity-item-table" }),
              content: currentActivityItem.activityItemAction,
              isolated: true,
            },
          ]}
        />

        <Divider style={{ backgroundColor: "#808080" }} />

        <DialogContent>
          {React.createElement(UploadContentMapper[type], {
            currentActivityItem,
            profile,
            refId,
            uploadType,
            setUploadType,
            onClose,
            entityDate,
          })}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UploadModal;
